import React, { memo, useState, useCallback } from 'react';
import { ListItemButton, ListItemIcon, ListItemText, Collapse } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import ExpandLess from '@mui/icons-material/ExpandLessRounded';
import ExpandMore from '@mui/icons-material/ExpandMoreRounded';

const styles = theme => ({
    text: {
        fontWeight: 500,
    },
    selected: {
        backgroundColor: theme.palette.action.hover,
    },
    collapse: {
        backgroundColor: theme.palette.background.paperDark
    }
});

const CollapsibleListItem = memo(({
    children,
    open,
    text,
    icon,
    classes,
    startOpen = false,
    onClick,
    ...other
}) => {
    const [localOpen, setLocalOpen] = useState(() => open === undefined ? !!startOpen : false);
    const isOpen = open !== undefined ? open : localOpen;

    const handleClick = useCallback(() => {
        if (onClick) {
            onClick();
        } else if (open === undefined) {
            setLocalOpen(prevOpen => !prevOpen);
        }
    }, [onClick, open, setLocalOpen]);

    return (
        <>
            <ListItemButton
                onClick={handleClick}
                className={isOpen ? classes.selected : undefined}
                aria-expanded={isOpen}
                {...other}
            >
                {icon && (
                    <ListItemIcon>
                        {icon}
                    </ListItemIcon>
                )}
                <ListItemText
                    primary={text}
                    classes={{ primary: classes.text }}
                />
                {isOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse
                in={isOpen}
                timeout="auto"
                unmountOnExit
                className={classes.collapse}
            >
                {children}
            </Collapse>
        </>
    );
});

export default withStyles(CollapsibleListItem, styles);